import * as zod from 'zod';

import type { DeviceInfo } from '@sb/messenger/auto_generated/messenger/skills_bot_service';

export const GPUTaskRunnerInferenceCommandEnum = zod.enum([
  'start_inference',
  'stop_inference',
  'delete_model',
]);

export const GPUTaskRunnerCommand = zod.object({
  kind: zod.literal('GPUTaskRunnerCommand'),
  equipmentId: zod.optional(zod.string()),
  subCommand: zod.union([
    zod.object({
      command: zod.literal('start_inference'),
      timeout: zod.number(),
    }),
    zod.object({
      command: zod.literal('stop_inference'),
    }),
    zod.object({
      command: zod.literal('configure_inference'),
      modelName: zod.string(),
      robotId: zod.string(),
      equipmentKeyToDeviceInfo: zod.record(
        zod.string(),
        zod.custom<DeviceInfo>(),
      ),
    }),
    zod.object({
      command: zod.literal('delete_model'),
      modelName: zod.string(),
    }),
  ]),
});

export type GPUTaskRunnerCommand = zod.infer<typeof GPUTaskRunnerCommand>;
